import React from "react";
import Modal from "react-modal";
import { Image } from "semantic-ui-react";
import { Player, BigPlayButton } from "video-react";
import LazyLoad from "react-lazyload";
import "video-react/dist/video-react.css";
import "./VideoModal.css";

class VideoModal extends React.Component {
  state = {
    isOpen: false,
    canDownload: false
  };

  openModal = () => this.setState({ isOpen: true });

  closeModal = () => this.setState({ isOpen: false });

  componentDidMount() {
    const { videoIndex } = this.props
    const { search } = window.location
    if (search.indexOf('v=') < 0) {
      return
    }
    let v = search.replace('?', "").split('&').filter(i => i.substring(0, 2) === "v=")[0].replace('v=', '')
    if (Number(v) === videoIndex) {
      this.setState({ isOpen: true })
    }
  }


  render() {
    const { isOpen } = this.state;
    const { thumb, video, showBtn, Component } = this.props;
    return (
      <div>
        <LazyLoad height={200}>
          {
            Component ? <Component onClick={this.openModal} {...this.props} /> : (
              <div className={showBtn ? "showBtn" : ""} onClick={this.openModal}>
                <Image src={thumb} alt="Demo Image" fluid />
              </div>
            )
          }
        </LazyLoad>
        {isOpen && (
          <Modal
            className="__video_modal"
            overlayClassName="__video_modal_overlay"
            isOpen={isOpen}
            onRequestClose={this.closeModal}
            ariaHideApp={false}
          >
            <Player src={video} autoPlay>
              <BigPlayButton position="center" />
            </Player>
          </Modal>)
        }
      </div>
    );
  }
}

export default VideoModal;
